import Modal from "../../../components/Modal";
import { TextInput } from "../../../components/TextInput";
import { Button } from "../../../components/Button";
import { useState, useEffect, useMemo } from "react";
import { api } from "../../../services/api";
import { ShowToast } from "../../../services/toast";
import { SelectInput } from "../../../components/SelectInput/SelectInput";
import { useApp } from "../../../services/app-context";
import { GroupTag } from "../sales-aid-modal/components/GroupTag";

function normalizeFileForm(file: any) {
    return { ...file, groups: file?.groups ?? [] };
}

export default function CohortAssignmentModal({ isOpen, onClose, file, onSuccess }: { isOpen: boolean, onClose: () => void, file: any, onSuccess: () => void }) {
    const [form, setForm] = useState<any>(() => normalizeFileForm(file));
    const [saving, setSaving] = useState(false);
    const { tenantProfile } = useApp();
    const groups = tenantProfile?.groups || [];
    const formGroups = form.groups ?? [];
    const options = useMemo(() => groups
        .filter((group) => !formGroups.includes(group.key))
        .map((group) => ({ label: group.name, value: group.key }) as { label: string; value: string }), [groups, formGroups]);

    const handleAssignCohort = () => {
        setSaving(true);
        api.renameSalesAidFile(file.id, { groups: form.groups }).then((res) => {
            if (res.status === 200) {
                ShowToast({
                    message: "Cohort reassigned successfully",
                    type: "success"
                });
                onSuccess();
            } else {
                ShowToast({
                    message: "Failed to reassign cohort",
                    type: "error"
                });
            }
            setSaving(false);
        }).catch((err) => {
            setSaving(false);
            ShowToast({
                message: "Failed to reassign cohort",
                type: "error"
            });
        });
    }

    const handleChange = (e: any) => {
        setForm({ ...form, groups: [...formGroups, e.target.value] });
    }


    useEffect(() => {
        if (isOpen) {
            setForm(normalizeFileForm(file));
        }
    }, [file, isOpen]);


    return (
        <Modal
            contentClassName="!px-0"
            title="Reassign Cohort"
            isOpen={isOpen}
            handleModal={onClose}
        >
            <div className="flex flex-col gap-4 px-5 mt-4">

                <div className="flex flex-col gap-1.5">
                    <span className="text-gray-701 text-xs font-semibold">Current Cohorts</span>
                    {formGroups.length > 0 && <div className="flex items-center gap-2">
                        {
                            formGroups.map((group: string) => (
                                <GroupTag key={group} selectedGroup={groups.find(g => g.key === group)} onRemove={() => setForm((prev: any) => ({ ...prev, groups: (prev.groups ?? []).filter((g: string) => g !== group) }))} />
                            ))
                        }
                    </div>}
                    {
                        formGroups.length === 0 && <div className="text-gray-701 text-[10px] font-light">No cohorts assigned</div>
                    }
                </div>
                <div className="flex flex-col gap-1.5">
                    <span className="text-xs font-semibold text-black-600">COHORT</span>
                    <SelectInput
                        options={options}
                        value={""}
                        onChange={handleChange}
                        placeholder="Select Cohort"
                        className="!h-8 !border-0 !text-xs"
                    />
                </div>
                <div className="flex justify-end mt-10 gap-2.5">
                    <Button variant="primary" onClick={onClose} disabled={saving} className="!rounded-full !text-black !w-24 hover:!opacity-80 !py-2.5 !bg-gray-201">Cancel</Button>
                    <Button variant="primary" onClick={handleAssignCohort} loading={saving} className="!rounded-full !min-w-24 !py-2.5">Reassign</Button>
                </div>
            </div>
        </Modal>
    )
}